<template>
  <span
    :class="`tw-bg-[#FFFFFF] tw-flex tw-justify-center tw-items-center tw-gap-[5px] tw-rounded-[4px] tw-px-[5px] tw-py-[3px] tw-text-[11px] tw-not-italic tw-font-[500] tw-leading-[130%] ${state
      .replaceAll(' ', '')
      .toLowerCase()}`"
    >{{ state }}</span
  >
</template>

<script setup lang="ts">
import { assessmentStatus } from "@/utils/constants";

defineProps({
  state: {
    type: String,
    default: assessmentStatus.complete,
  },
});
</script>

<style scoped>
.inprogress {
  background: #fff;
  border: 1px solid var(--ui-blue-soft, #cfe7ff);
  color: #387dff;
}

.defunct {
  background: #fff;
  border: 1px solid var(--ui-orange-soft, #fee5e2);
  color: #f7553c;
}

.completed {
  background: #fff;
  border: 1px solid var(--ui-green-soft, #d9ede2);
  color: #01893d;
}

.audited {
  background: #fff;
  border: 1px solid #eee4f9;
  color: #904bd6;
}

.paused {
  background: #fff;
  border: 1px solid #fff0da;
  color: #fe9a05;
}

.created {
  background: #fff;
  border: 1px solid #fee5e2;
  color: #f7553c;
}
</style>
